import {Injectable} from '@angular/core';

@Injectable()
export class WindowWebservice {
  get windowRef() {
    return window;
  }
}
